module.exports = __webpack_public_path__ + "static/phone-aa0752a72fcba30f29ff38094493716d.svg";